export default __webpack_public_path__ + "maps-examples-dds-circle-layer-thumbnail-480-31fe9a15416f5604c83751cf88a028b7.webp";